import { ShareableType } from '@bindoc-projects/resource-domain-lib';

export class BdGrantRequestsStore {
  constructor(private readonly _baseUrl: string) {}

  public base(): string {
    return `${this._baseUrl}/grant-requests/`;
  }

  public myRequests(): string {
    return `${this.base()}my-requests/`;
  }

  public inbox(): string {
    return `${this.base()}inbox/`;
  }

  public forShareable(type: ShareableType, id: string): string {
    return `${this.base()}${type}/${id}/`;
  }

  public accept(requestId: string): string {
    return `${this.base()}${requestId}/accept`;
  }

  public dismiss(requestId: string): string {
    return `${this.base()}${requestId}/dismiss`;
  }
}
